import { Card, Row, Tabs, Form, Button, Col } from 'antd'
import React, { useState } from 'react'
import Image from '../Image'
import HeroAddress from '../Address'
import HeroTruck from '../Truck'
import HeroFollower from '../HeroFollower'
import HeroFollowing from '../HeroFollowing'
import HeroDocument from '../Document'
import HeroCoin from '../Coin'
import HeroBankAccount from '../BankAccount'
import HeroForm from '../HeroForm'
import HeroProducts from '../HeroProducts'
import LocationForm from '../LocationForm'
import Location from '../Location'
import LocationMap from '../PickLocation'
import { useDeepEffect } from '../../../../utils/hooks'
import _, { isEmpty } from 'lodash'
import HeroBin from '../HeroBin'
import { useDispatch, useSelector } from 'react-redux'
import { fetchLocationByHero } from '../../../../modules/location'
import { getHeroDetail, saveHeroLocation } from '../../../../modules/hero'
import HeroLoma from '../HeroLoma'

const HeroModal = ({
  heroConfigs,
  formData,
  statusOptions,
  heroTypeOptions,
  visible,
  onClose,
  onOk
}) => {
  const dispatch = useDispatch()
  const [heroConfig, setHeroConfig] = useState(null)

  const { locationList, heroDetail } = useSelector(
    (state) => ({
      locationList: state.location.locationList,
      heroDetail: state.hero.heroDetail
    }),
    []
  )

  async function fetch() {
    await dispatch(fetchLocationByHero(formData.id))
    await dispatch(getHeroDetail(formData.id))
  }

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      fetch()
    }
  }, [formData])

  useDeepEffect(() => {
    if (formData) {
      const config = _.find(heroConfigs, (item) => {
        return item.heroType === formData.heroType
      })
      setHeroConfig(config)
    }
  }, [formData])

  async function onSaveLocation(data) {
    await dispatch(saveHeroLocation(data))
    await dispatch(fetchLocationByHero(formData.id))
  }

  return (
    <Card
      footer={null}
      visible={visible}
      title={!isEmpty(formData) ? 'Edit hero' : 'Create a new hero'}
      extra={
        <div>
          <Button size="small" icon="close" onClick={() => onClose()}>
            close
          </Button>
        </div>
      }
      destroyOnClose={true}
      width={1000}>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Hero Profile" key="1">
          <HeroForm
            onOk={onOk}
            data={formData}
            heroDetail={heroDetail}
            statusOptions={statusOptions}
            heroTypeOptions={heroTypeOptions}
          />
        </Tabs.TabPane>
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Hero Locations" key="2">
            {/* {locationList && locationList.length > 0 && (
              <LocationMap
                draggable={false}
                hero={heroDetail}
                locationList={locationList}
                heroConfigs={heroConfigs}
              />
            )} */}
            {/* {!isEmpty(formData) && (
              <Row type="flex" gutter={8}> */}
            <Location
              hero={heroDetail}
              heroId={formData.id}
              heroConfigs={heroConfigs}
            />
            {/* </Row>
            )} */}
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Image" key="3">
            <Image data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Address" key="4">
            <HeroAddress data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) &&
          (formData.heroType !== 'CIRCULAR_BIN' ? (
            <Tabs.TabPane tab="Products" key="5">
              <HeroProducts hero={formData} />
            </Tabs.TabPane>
          ) : (
            <Tabs.TabPane tab="Bin" key="5">
              <HeroBin hero={formData} />
            </Tabs.TabPane>
          ))}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Documents" key="6">
            <HeroDocument data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Coins" key="7">
            <HeroCoin data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Truck" key="8">
            <HeroTruck data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Bank Account" key="9">
            <HeroBankAccount data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="คู่ค้า" key="10">
            <HeroFollowing data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="ลูกค้า" key="11">
            <HeroFollower data={heroDetail} />
          </Tabs.TabPane>
        )}
        {!isEmpty(formData) && (
          <Tabs.TabPane tab="Loma User" key="12">
            <HeroLoma data={heroDetail} />
          </Tabs.TabPane>
        )}
      </Tabs>
    </Card>
  )
}
const WrappedHeroModal = Form.create({ name: 'HeroModal' })(HeroModal)
export default WrappedHeroModal
